module.exports = __webpack_public_path__ + "img/home-popup-title2.a88ab7ab.png";